import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { APPLICATION_NAME_TOKEN, ApplicationName } from '@ddt-web/config';
import { Notification, NotificationsService, NotificationType } from '@ddt-web/notifications';
import { Observable } from 'rxjs';

import { PopupDialogAction, PopupDialogActionOptions, PopupDialogObject } from '../models/popup-dialog-object';

@Injectable()
export class ErrorHelperService {

	constructor(
		private router: Router,
		@Inject(APPLICATION_NAME_TOKEN) private applicationName: ApplicationName,
		private notificationsService: NotificationsService
	) { }

	public getRouterUrl(): string {
		return this.router.url;
	}

	public getRouterUrlParam(param: string): string {
		const urlTree = this.router.parseUrl(this.getRouterUrl());
		return urlTree.queryParams[param] || '';
	}

	public getApplicationName(): string {
		return this.applicationName;
	}

	public buildPopupDialogObject(description: string, label: string, reload: boolean, dialogErrorMessage: PopupDialogObject): PopupDialogObject {
		dialogErrorMessage.description = description;
		dialogErrorMessage.actions = [
			PopupDialogAction.create({
				label: label,
				reload: reload
			} as PopupDialogActionOptions)
		];
		return dialogErrorMessage;
	}

	public addNotification(channel: string, message: string, icon: string, duration: number, type: NotificationType = NotificationType.CONFIRMATION): Notification {
		return this.notificationsService.addNotification({ channel, message, icon, duration, type });
	}

	public getVisibleNotificationsByChannel$(channels: string[]): Observable<Notification[]> {
		return this.notificationsService.getVisibleNotificationsByChannel$(channels);
	}

	public dismissNotification(id: string): void {
		this.notificationsService.dismissNotification(id);
	}
}
